const ROOT_KEYS = new Set(['payload', 'meta']);
/** 형제 키 레거시(마이그레이션 직전 형태) */
const LEGACY_SIBLING_KEYS = new Set(['payload', 'debug', 'pagination']);
function isPagination(value) {
    if (!value || typeof value !== 'object') {
        return false;
    }
    const pagination = value;
    return (typeof pagination.page === 'number' &&
        typeof pagination.size === 'number' &&
        typeof pagination.totalCount === 'number');
}
function normalizeMeta(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return undefined;
    }
    const record = value;
    const meta = {};
    if (isPagination(record.pagination)) {
        meta.pagination = record.pagination;
    }
    if ('debug' in record) {
        meta.debug = record.debug;
    }
    return Object.keys(meta).length > 0 ? meta : undefined;
}
function withMeta(envelope, meta) {
    if (!meta || Object.keys(meta).length === 0) {
        return envelope;
    }
    return { ...envelope, meta };
}
function isPayloadMetaShape(value) {
    const keys = Object.keys(value);
    return keys.length > 0 && keys.every((key) => ROOT_KEYS.has(key));
}
function isLegacySiblingShape(value) {
    const keys = Object.keys(value);
    if (keys.length === 0) {
        return false;
    }
    return keys.every((key) => LEGACY_SIBLING_KEYS.has(key)) && !('meta' in value);
}
function fromLegacySiblings(value) {
    const envelope = {};
    if ('payload' in value) {
        envelope.payload = value.payload;
    }
    const meta = {};
    if (isPagination(value.pagination)) {
        meta.pagination = value.pagination;
    }
    if ('debug' in value) {
        meta.debug = value.debug;
    }
    return withMeta(envelope, Object.keys(meta).length > 0 ? meta : undefined);
}
function mergeMeta(into, from) {
    if (!from) {
        return;
    }
    if (from.pagination && !into.pagination) {
        into.pagination = from.pagination;
    }
    if ('debug' in from && !('debug' in into)) {
        into.debug = from.debug;
    }
}
export function toEnvelope(body, method = 'GET') {
    if (body === undefined || body === null) {
        return body;
    }
    if (typeof body !== 'object' || Array.isArray(body)) {
        if (Array.isArray(body)) {
            return { payload: body };
        }
        return body;
    }
    const record = body;
    if (isPayloadMetaShape(record)) {
        const envelope = {};
        if ('payload' in record) {
            envelope.payload = record.payload;
        }
        return withMeta(envelope, normalizeMeta(record.meta));
    }
    if (isLegacySiblingShape(record)) {
        return fromLegacySiblings(record);
    }
    if ('data' in record && Object.keys(record).length === 1) {
        return { payload: record.data };
    }
    const rest = { ...record };
    const meta = {};
    if (isPagination(rest.pagination)) {
        meta.pagination = rest.pagination;
        delete rest.pagination;
    }
    if ('meta' in rest) {
        mergeMeta(meta, normalizeMeta(rest.meta));
        delete rest.meta;
    }
    const envelope = {};
    if ('payload' in rest) {
        envelope.payload = rest.payload;
    }
    else {
        const keys = Object.keys(rest);
        if (keys.length > 0) {
            envelope.payload = rest;
        }
        else if (method === 'GET' || method === 'HEAD') {
            envelope.payload = {};
        }
    }
    return withMeta(envelope, Object.keys(meta).length > 0 ? meta : undefined);
}
export function isApiEnvelope(body) {
    if (!body || typeof body !== 'object' || Array.isArray(body)) {
        return false;
    }
    const record = body;
    const keys = Object.keys(record);
    if (keys.length === 0) {
        return false;
    }
    return keys.every((key) => ROOT_KEYS.has(key));
}
export function unwrapEnvelope(body) {
    if (isApiEnvelope(body)) {
        return body;
    }
    return toEnvelope(body);
}
export function requirePayload(envelope) {
    if (envelope.payload === undefined) {
        throw new Error('API 응답에 payload가 없습니다.');
    }
    return envelope.payload;
}
//# sourceMappingURL=to-envelope.js.map